import { gql } from "graphql-request"
import { ServiceGraphql } from "./Graphql"

export const transactionHistory = async (data) => {
  const TRANSACTION_HISTORY = gql`
  query TransactionHistory($contractId: Int!, $fromDate: String, $toDate: String) {
    TransactionHistory(contractId: $contractId, fromDate: $fromDate, toDate: $toDate) {
      data
      status
    }
  }
  `

  const response = await ServiceGraphql.request(TRANSACTION_HISTORY, data);
  return response.TransactionHistory;
}